module.exports = __webpack_public_path__ + "static/3-f63801f5cddd1b5ff45e2abcee230b8d.svg";